// extracted by mini-css-extract-plugin
module.exports = {"Skills":"skills_Skills__1GD2Y","SkillsPage":"skills_SkillsPage__22Xxm","SpinIcon":"skills_SpinIcon__3Q5BA","rotating":"skills_rotating__3jkl7"};